<template>
  <div :data-testid="getTestId('admin-project-page')">
    <ProjectCrudTable :data-testid="getTestId('admin-project-table')" />
  </div>
</template>

<script>
import { getTestId } from '@/utils/testUtils';

export default {
  name: 'ProjectPage',
  components:{
    ProjectCrudTable: () => import('../../components/table/ProjectCrudTable')
  },
  methods: {
    getTestId(testId) {
      return getTestId(testId);
    }
  }
};
</script>

<style scoped>

</style>
